import { useEffect, useState, useCallback } from "react";

export function RegisterSW() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    let reg: ServiceWorkerRegistration | null = null;

    const onControllerChange = () => {
      // Un nouveau SW a pris le contrôle → recharger pour utiliser la nouvelle version
      window.location.reload();
    };

    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        reg = registration;

        // Forcer la vérification de mise à jour à chaque chargement
        registration.update().catch(() => {});

        // Vérifier s'il y a une mise à jour en attente
        const onUpdateFound = () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener("statechange", () => {
            // Le nouveau SW est installé et il y a déjà un SW actif
            if (
              newWorker.state === "activated" &&
              navigator.serviceWorker.controller
            ) {
              // skipWaiting: true → le SW s'active automatiquement
              // Afficher le bandeau pour que l'utilisateur confirme le reload
              setShowBanner(true);
            }
          });
        };

        registration.addEventListener("updatefound", onUpdateFound);
      })
      .catch((err) => {
        console.error("SW registration failed:", err);
      });

    navigator.serviceWorker.addEventListener(
      "controllerchange",
      onControllerChange
    );

    return () => {
      navigator.serviceWorker.removeEventListener(
        "controllerchange",
        onControllerChange
      );
    };
  }, []);

  const handleUpdate = useCallback(() => {
    setShowBanner(false);
    window.location.reload();
  }, []);

  if (!showBanner) return null;

  return (
    <div className="fixed left-4 right-4 top-4 z-50 flex items-center justify-between rounded-lg border border-border bg-card p-3 shadow-md">
      <p className="text-sm text-foreground">
        Nouvelle version disponible
      </p>
      <div className="flex gap-2">
        <button
          onClick={() => setShowBanner(false)}
          className="text-sm text-muted-foreground"
        >
          Plus tard
        </button>
        <button
          onClick={handleUpdate}
          className="rounded-md bg-primary px-3 py-1 text-sm font-medium text-primary-foreground"
        >
          Mettre à jour
        </button>
      </div>
    </div>
  );
}
